import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";

import app1 from "../app1.png";
import app2 from "../app2.png";
import app3 from "../app3.png";
import app4 from "../app4.png"; // Added app4

const Body = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const visited = localStorage.getItem('visited_coe');
    if (!visited) {
      setShowModal(true);
      localStorage.setItem('visited_coe', 'true');
    }
  }, []);

  const styles = {
    container: {
      /* Change height to 100% of the parent flex box */
      flex: 1,
      height: 'calc(100vh - 150px)', // Adjust 150px based on your Header+Footer height
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: '"Segoe UI", Roboto, sans-serif',
      // backgroundColor: '#f8f9fa',
      overflow: 'hidden' // THIS PREVENTS SCROLLING ON THE HOME PAGE
    },
    headerSection: {
      textAlign: 'center',
      marginBottom: '30px',
      maxWidth: '800px'
    },
    title: { color: '#1a3a5a', fontSize: '1.4rem', fontWeight: '800', marginBottom: '10px' },
    subTitle: { color: '#4a5568', fontSize: '1rem' },
    cardContainer: {
      display: 'flex',
      gap: '20px',
      width: '100%',
      maxWidth: '800px', justifyContent: 'center',
      flexWrap: 'wrap'
    },
    actionCard: {
      background: '#ffffff',
      padding: '30px',
      borderRadius: '16px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      flex: '1',
      minWidth: '280px',
      border: '1px solid #e1e8ed'
    },
    btnStyle: {
      display: 'inline-block',
      padding: '15px 25px',
      fontSize: '1.1rem',
      fontWeight: '700',
      borderRadius: '10px',
      textDecoration: 'none',
      width: '100%',
      transition: '0.3s'
    },
    modalOverlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: '20px'
    },
    modalContent: {
      backgroundColor: 'white',
      borderRadius: '20px',
      maxWidth: '750px', // Increased width for 4 images
      width: '100%',
      maxHeight: '90vh',
      overflowY: 'auto',
      padding: '25px',
      position: 'relative'
    },
    guideBtn: {
      backgroundColor: '#f57f17',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '50px',
      fontWeight: 'bold',
      cursor: 'pointer',
      marginBottom: '20px',
      boxShadow: '0 4px 15px rgba(245,127,23,0.4)'
    },
    appImage: {
      width: '100%',
      maxWidth: '150px', // Slightly smaller to fit 4 in a row better
      borderRadius: '8px',
      marginTop: '10px',
      border: '1px solid #ddd',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    },
    imageContainer: {
      display: 'flex',
      gap: '10px',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginTop: '15px',
      backgroundColor: '#f1f3f5',
      padding: '15px',
      borderRadius: '12px'
    },
    loginNote: {
      backgroundColor: '#fff3cd',
      color: '#856404',
      padding: '12px',
      borderRadius: '8px',
      fontSize: '13px',
      marginTop: '15px',
      border: '1px solid #ffeeba'
    }
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          .btn-primary-custom { background-color: #007bff; color: white; }
          .btn-success-custom { background-color: #28a745; color: white; }
          .step-badge { background: #007bff; color: white; width: 28px; height: 28px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; margin-right: 10px; font-size: 14px; flex-shrink: 0; }
          .step-item { margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #eee; }
          .urdu-text { font-family: 'Tahoma'; direction: rtl; display: block; margin-top: 5px; color: #555; font-size: 14px; }
          @media (max-width: 600px) {
            .action-card { padding: 20px !important; }
            h6 { font-size: 1.1rem !important; }
            .app-image-wrapper { width: 45%; }
          }
        `}
      </style>

      <button style={styles.guideBtn} onClick={() => setShowModal(true)}>
        📖 View Application Steps (طریقہ کار دیکھیں)
      </button>

      <div style={styles.headerSection}>
        <h6 style={styles.title}>Application Form for Scholarship/Admission in Class 7th in Centers of Excellence</h6>
        <p style={styles.subTitle}>Under the scheme provision of Free & Quality Education for Talented Students of Government Schools of Khyber Pakhtunkhwa</p>
      </div>

      <div style={styles.cardContainer}>
        <div className="action-card" style={styles.actionCard}>
          <span className="urdu-text" style={{ marginBottom: '10px' }}>اگر آپ نے ابھی تک اپلائی نہیں کیا</span>
          <Link to="new" className="btn-success-custom" style={styles.btnStyle}>New Applicant</Link>
        </div>

        <div className="action-card" style={styles.actionCard}>
          <span className="urdu-text" style={{ marginBottom: '10px' }}>چالان ڈاؤن لوڈ کرنے کے لیے</span>
          <Link to="/search" className="btn-primary-custom" style={styles.btnStyle}>Already Applied</Link>
        </div>
      </div>

      {showModal && (
        <div style={styles.modalOverlay} onClick={() => setShowModal(false)}>
          <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
            <button
              onClick={() => setShowModal(false)}
              style={{ position: 'absolute', right: '20px', top: '15px', border: 'none', background: 'none', fontSize: '24px', cursor: 'pointer' }}
            >
              &times;
            </button>

            <h4 style={{ color: '#1a3a5a', textAlign: 'center', marginBottom: '25px', fontWeight: 'bold' }}>
              Application Guide (رہنمائی)
            </h4>

            {/* Step 1 */}
            <div className="step-item">
              <div style={{ fontWeight: '700' }}><span className="step-badge">1</span> Online Registration</div>
              <p style={{ fontSize: '14px', margin: '5px 0' }}>Click 'New Applicant' on this website to fill the form.</p>
              <span className="urdu-text">ویب سائٹ پر 'New Applicant' پر کلک کر کے فارم پُر کریں۔</span>
            </div>

            {/* Step 2 */}
            <div className="step-item">
              <div style={{ fontWeight: '700' }}><span className="step-badge">2</span> App Login & Photo Upload</div>
              <p style={{ fontSize: '14px', margin: '5px 0' }}>Install <b>ETEA Official</b> App from Play Store. Log in using your <b>CNIC</b> as both cnic and password.</p>

              <div style={styles.imageContainer}>
                <div className="app-image-wrapper">
                  <img src={app1} alt="More Section" style={styles.appImage} />
                  <p style={{ fontSize: '11px', textAlign: 'center', fontWeight: 'bold' }}>1. Click More</p>
                </div>
                <div className="app-image-wrapper">
                  <img src={app2} alt="Login Section" style={styles.appImage} />
                  <p style={{ fontSize: '11px', textAlign: 'center', fontWeight: 'bold' }}>2. Click Login</p>
                </div>
                <div className="app-image-wrapper">
                  <img src={app3} alt="Enter Credentials" style={styles.appImage} />
                  <p style={{ fontSize: '11px', textAlign: 'center', fontWeight: 'bold' }}>3. Login with CNIC</p>
                </div>
              </div>

              <div style={styles.loginNote}>
                <strong>Login Credentials:</strong> Enter your 13-digit CNIC in the CNIC field and the <b>same CNIC</b> in the Password field.
                <span className="urdu-text" style={{ color: '#856404' }}>یوزرنیم اور پاس ورڈ دونوں جگہوں پر اپنا شناختی کارڈ نمبر درج کریں۔</span>
              </div>
            </div>

            {/* Updated Step 3 */}
            <div className="step-item">
              <div style={{ fontWeight: '700' }}><span className="step-badge">3</span> Check Final Submission Status</div>
              <p style={{ fontSize: '14px', margin: '5px 0' }}>
                Go to the <b>"Already Applied"</b> section on this website and search with your CNIC.
                Ensure you see <b>Green Ticks (✅)</b> for Application and Picture.
              </p>

              <div style={{ textAlign: 'center', marginTop: '10px', backgroundColor: '#eef2f7', padding: '15px', borderRadius: '10px' }}>
                <img src={app4} alt="Check Status" style={{ ...styles.appImage, maxWidth: '280px', border: '2px solid #007bff' }} />
                <p style={{ fontSize: '11px', fontWeight: 'bold', color: '#007bff', marginTop: '5px' }}>
                  Verify your Status & Photo here after using the App
                </p>
              </div>

              <span className="urdu-text">
                ویب سائٹ پر <b>"Already Applied"</b> والے بٹن پر کلک کر کے اپنا شناختی کارڈ نمبر لکھ کر سرچ کریں۔ اگر آپ کی تصویر اور فارم کے سامنے <b>(✅)</b> کا نشان ہے تو آپ کی درخواست مکمل ہے۔
              </span>
            </div>

            {/* Step 4 remains for the Challan */}
            <div className="step-item" style={{ border: 'none' }}>
              <div style={{ fontWeight: '700' }}><span className="step-badge">4</span> Download & Pay Challan</div>
              <p style={{ fontSize: '14px', margin: '5px 0' }}>Once your status is verified, download the <b>Fee Voucher</b> from the same search page and pay it.</p>
              <span className="urdu-text">اسٹیٹس چیک کرنے کے بعد وہیں سے اپنا فیس چالان ڈاؤن لوڈ کریں اور جمع کروائیں۔</span>
            </div>



            <button
              className="btn-primary-custom"
              style={{ ...styles.btnStyle, marginTop: '10px' }}
              onClick={() => setShowModal(false)}
            >
              Close Guide (بند کریں)
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default Body;